import { render, staticRenderFns } from "./KonveyPlans.vue?vue&type=template&id=6f6816dd"
import script from "./KonveyPlans.vue?vue&type=script&lang=js"
export * from "./KonveyPlans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports